import axios from "axios";
import { call, put, takeEvery, takeLatest, select } from "redux-saga/effects";
import constants from "constants";
import actions from "actions";
import { toast } from "react-toastify";
import { goBack } from "redux-router";
import { normalizeHolidays } from "services/bankHolidays";

const {
  addErrorsSaga,
  endRequest,
  addCalendarBookings,
  addBookingHolidays,
  addCalendarBooking,
  addAdminCalendarBookings,
  putAdminCalendarBooking,
  addCalendarEditBookings,
  addCalendarSponsorBookings,
} = actions;

const {
  CREATE_CALENDAR_BOOKING,
  LOAD_CALENDAR_BOOKINGS,
  API_CALENDAR_BOOKINGS,
  UPDATE_CALENDAR_SAGA,
  LOAD_ADMIN_CALENDAR_BOOKINGS,
  LOAD_SPONSOR_BOOKINGS,
  API_ADMIN_CALENDAR_BOOKINGS,
  API_SPONSOR_BOOKINGS,
  ADMIN_DELETE_BOOKINGS_SAGA,
  ADMIN_BOOKINGS_APPROVE_REJECT,
  LOAD_CALENDAR_BOOKING,
} = constants;

const startDateError = (errorMessages) =>
  errorMessages &&
  errorMessages.start_date &&
  errorMessages.start_date.length &&
  `Start date ${errorMessages.start_date[0]}`;

const apiLoadCalendarBookings = (params) =>
  axios.get(API_CALENDAR_BOOKINGS + params);
const apiCreateBooking = (booking) =>
  axios.post(API_CALENDAR_BOOKINGS, { booking });
const apiUpdateBooking = (booking) =>
  axios.put(`${API_ADMIN_CALENDAR_BOOKINGS}/${booking.id}`, { booking });
const apiAdminLoadCalendarBookings = (params) =>
  axios.get(API_ADMIN_CALENDAR_BOOKINGS + params);
const apiloadSponsorBookings = (params) =>
  axios.get(API_SPONSOR_BOOKINGS + params);
const apiAdminBookingsApproveReject = (params, booking) =>
  axios.put(API_ADMIN_CALENDAR_BOOKINGS + params, booking);

function* loadCalendarBookingSaga({ period, userTypes }) {
  try {
    let userTypesParams = "";
    userTypes.forEach((type) => (userTypesParams += `user_types[]=${type}&`));
    const response = yield call(
      apiLoadCalendarBookings,
      `?${userTypesParams}range_calendar=${period}`
    );
    console.log(response);
    yield put(addCalendarBookings(response.data.bookings));
    if (response.data.holidays) {
      yield put(addBookingHolidays(normalizeHolidays(response.data.holidays)));
    }
  } catch (e) {
    yield put(endRequest("booking_create"));
  }
}

function* loadCalendarBooking({ id }) {
  try {
    const response = yield call(apiAdminLoadCalendarBookings, `/${id}`);
    console.log(response);
    yield put(addCalendarEditBookings(response.data.booking));
  } catch (e) {
    yield put(endRequest("booking_create"));
  }
}

function* loadAdminCalendarBookingSaga({
  page,
  booking_type = "",
  user_types = [],
  period = "",
  order = {},
}) {
  try {
    let userTypesParams = "";
    user_types.forEach((type) => (userTypesParams += `user_types[]=${type}&`));

    let orderParams = "";
    Object.keys(order).forEach((field) => {
      orderParams += `order[${field}]=${order[field]}&`;
    });

    const response = yield call(
      apiAdminLoadCalendarBookings,
      `?${userTypesParams}range_calendar=${period}&booking_type=${booking_type}&${orderParams}page=${page}&per_page=10`
    );
    const { bookings, pages } = response.data;

    yield put(addAdminCalendarBookings({ values: bookings, page, pages }));
  } catch (e) {
    toast.success("Oops, something went wrong...");
  }
}

function* loadSponsorBookingsSaga({
  page,
  booking_type = "",
  user_types = [],
  period = "",
}) {
  // debugger
  try {
    let userTypesParams = "";
    user_types.forEach((type) => (userTypesParams += `user_types[]=${type}&`));
    const response = yield call(
      apiloadSponsorBookings,
      `?page=${page}&per_page=10`
    );
    const { bookings, pages } = response.data;

    yield put(addCalendarSponsorBookings({ values: bookings, page, pages }));
  } catch (e) {
    toast.success("Oops, something went wrong...");
  }
}

function* createBookingSaga({ data }) {
  try {
    const response = yield call(apiCreateBooking, data);
    const { booking, error_messages } = response.data;
    if (error_messages) {
      toast.success(
        error_messages.base
          ? error_messages.base[0]
          : startDateError(error_messages) || "Slot is in use"
      );
    }
    if (booking) {
      yield put(addCalendarBooking(booking));
      localStorage.setItem("show_booking_toast", "true");
      window.location.reload();
    }
  } catch (e) {
    const { response } = e;
    const { status, data } = response || {};

    if (status === 400 && data.error_messages) {
      if (data.error_messages.base) {
        toast.success(data.error_messages.base[0]);
      } else if (startDateError(data.error_messages)) {
        toast.error(startDateError(data.error_messages));
      } else {
        toast.success("Oops, something went wrong...");
      }
    } else {
      toast.success("Oops, something went wrong...");
    }
  }
}

function* updateCalendarSaga({ booking }) {
  try {
    booking = { ...booking, booking_experts_attributes: booking.booking_experts };
    delete booking.booking_experts;
    const response = yield call(apiUpdateBooking, booking);
    const responseData = response.data;

    const { error_messages } = responseData;
    const bookingData = responseData && responseData.booking;

    if (error_messages) {
      toast.success(
        error_messages.base
          ? error_messages.base[0]
          : startDateError(error_messages) || "Slot is in use"
      );
    }
    if (bookingData) {
      // yield put(addCalendarBooking(booking));
      toast.success("Booking successfully updated!");
      // yield put(push('/calendar'));
      yield put(goBack());
    }
  } catch (e) {
    const { status, data } = e.response || {};
    const message =
      status === 400 && data && data.error_messages
        ? startDateError(data.error_messages)
        : null;
    if (message) {
      toast.error(message);
    } else {
      toast.success("Oops, something went wrong...");
    }
  }
}

function* apiDeleteBookings(booking_ids) {
  return axios.post(
    API_ADMIN_CALENDAR_BOOKINGS +
      "/destroy" +
      `?${booking_ids.map(
        (item, index) => `${index > 0 ? "&" : ""}booking_ids[]=${item}`
      )}`
  );
}

function* deleteBookings({ booking_ids, query }) {
  if (!booking_ids.length) return;
  const bookingsIds = booking_ids;
  try {
    yield call(apiDeleteBookings, bookingsIds);
    toast.success("Bookings successfully deleted!");
    const pageAdmin = yield select(
      (state) => state.bookings.adminBooking.page
    ) || 1;
    const pageSponsor = yield select(
      (state) => state.bookings.sponsorBookings.page
    ) || 1;
    yield call(loadAdminCalendarBookingSaga, { ...query, page: pageAdmin });
    yield call(loadSponsorBookingsSaga, { ...query, page: pageSponsor });
  } catch (e) {
    yield put(addErrorsSaga(ADMIN_DELETE_BOOKINGS_SAGA, e.response));
  }
}

function* adminBookingApproveReject({ id, bookingType }) {
  try {
    const response = yield call(apiAdminBookingsApproveReject, `/${id}`, {
      booking_type: bookingType,
    });
    console.log(response);
    const { booking, error_messages } = response.data;

    if (error_messages) {
      toast.success(
        error_messages.base ? error_messages.base[0] : "Slot is in use"
      );
    }
    if (booking) {
      yield put(putAdminCalendarBooking(booking));
      toast.success("Booking successfully updated!");
    }
  } catch (e) {
    toast.success("Oops, something went wrong...");
  }
}

function* __createBookingSaga() {
  yield takeEvery(CREATE_CALENDAR_BOOKING, createBookingSaga);
}

function* __loadCalendarBookingSaga() {
  yield takeEvery(LOAD_CALENDAR_BOOKINGS, loadCalendarBookingSaga);
}

function* __loadAdminCalendarBookingSaga() {
  yield takeEvery(LOAD_ADMIN_CALENDAR_BOOKINGS, loadAdminCalendarBookingSaga);
}

function* __loadSponsorBookingsSaga() {
  yield takeEvery(LOAD_SPONSOR_BOOKINGS, loadSponsorBookingsSaga);
}

function* __adminDeleteBookingsSaga() {
  yield takeEvery(ADMIN_DELETE_BOOKINGS_SAGA, deleteBookings);
}

function* __updateCalendarSaga() {
  yield takeEvery(UPDATE_CALENDAR_SAGA, updateCalendarSaga);
}

function* __adminBookingApproveReject() {
  yield takeEvery(ADMIN_BOOKINGS_APPROVE_REJECT, adminBookingApproveReject);
}

function* __loadCalendarBooking() {
  yield takeEvery(LOAD_CALENDAR_BOOKING, loadCalendarBooking);
}

export {
  __createBookingSaga,
  __loadCalendarBookingSaga,
  __loadAdminCalendarBookingSaga,
  __loadSponsorBookingsSaga,
  __updateCalendarSaga,
  __adminBookingApproveReject,
  __loadCalendarBooking,
  __adminDeleteBookingsSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/calendar.js